import { render, staticRenderFns } from "./custom_form.vue?vue&type=template&id=f431d606&scoped=true"
import script from "./custom_form.vue?vue&type=script&lang=js"
export * from "./custom_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f431d606",
  null
  
)

export default component.exports